module.exports = __webpack_public_path__ + "static/media/milesProgram.bcb20a43.svg";